import * as Sentry from "@sentry/react";

// todo: https://docs.sentry.io/platforms/javascript/guides/react/#react-19-error-reporting
if (
  import.meta.env.VITE_ENVIRONMENT &&
  !import.meta.env.VITE_REACT_SUPPRESS_SENTRY
) {
  Sentry.init({
    dsn: "https://1a43ef6751a3b4d948f036db3645fa2a@o4506519499309056.ingest.us.sentry.io/4510030057832448",
    integrations: [
      // Sentry.replayIntegration(),
      // Sentry.feedbackIntegration({
      //   // Additional SDK configuration goes in here, for example:
      //   colorScheme: "system",
      // }),
    ],
    // Exceptions filtering
    beforeSend(event, hint) {
      if (
        hint.originalException instanceof DataCloneError &&
        hint.originalException.message.includes("The object can not be cloned.")
      ) {
        return null;
      }
      return event;
    },
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.3,
    environment: import.meta.env.VITE_ENVIRONMENT,
  });
}

class DataCloneError extends Error {
  constructor(message) {
    super(message);
    this.name = "DataCloneError";
  }
}
